import { WorkspaceStore } from './../../../services/stores/workspace.store';
import { VideoListComponent } from './../../../modules/catch-core/component/video-list/video-list.component';
import { GlobalSettingStore } from './../../../services/stores/global-setting.store';
import { IYouTubeVideoModel } from './../../../models/global-setting/global-setting.model';
import { AppNames } from '../../../modules/catch-core/data/enum/app-name.enum';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { OrganizationStore } from '../../../services/stores/organization.store';
import { DomSanitizer } from '@angular/platform-browser';
import { DashboardHelper } from '../../../services/dashboard.service';
import { PromptService } from '../../../services/prompt.service';
import { BaseComponent } from '../../base/base.component';
import { Router } from '@angular/router';
import { ExternalLinkStore } from '../../../services/stores/external-link.store';
import { ProjectStore } from '../../../services/stores/projects.store';
import { isFranklyProductType } from '../../../modules/catch-core/data/helpers/product-type.helper';
import { AlertService, INotificationHistoryItem } from '../../../services/alert.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class HeaderComponent extends BaseComponent implements OnInit {
  _announcementText: string = '';
  public notificationHidden: boolean = false;
  public globalNotificationHidden: boolean = false;
  currentApplicationName = '';
  version = '';
  organization: any;
  isClassicETActive: boolean = false;
  public gobalAnnouncement: string = '';
  public isLoading$ = this.projectStore.$isLabelListLoading;

  public vidoeList: IYouTubeVideoModel[] = [];

  public notifications: INotificationHistoryItem[] = [];
  public notificationCount: number = 0;

  constructor(
    private projectStore: ProjectStore,
    public organizationStore: OrganizationStore,
    private dashboardHelper: DashboardHelper,
    private promptsService: PromptService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private externalLinkStore: ExternalLinkStore,
    private sanitizer: DomSanitizer,
    private globalSettingStore: GlobalSettingStore,
    private alertService: AlertService,
  ) {
    super();
    this.notificationHidden = false;
  }

  ngOnInit() {
    this.subscribers.currentApp = this.dashboardHelper.currentAppMode.subscribe((app) => {
      if (app) {
        this.currentApplicationName = app;
      }
    });

    this.subscribers.organisation = this.organizationStore.$firstOrganization.subscribe((o) => {
      if (o) {
        this.organization = o;
        this.cdr.detectChanges();
      }
    });

    this.subscribers.externalLinks = this.externalLinkStore.$orgExternalLink.subscribe((exLink) => {
      if (exLink) {
        let appArray = exLink.externalLinks;
        this.isClassicETActive = appArray.some((app: any) => isFranklyProductType(app.productType) && app.active);
      }
    });

    this.subscribers.announcementMessage = this.globalSettingStore.$announcementMessage.subscribe((res: string) => {
      if (res !== null) {
        this.gobalAnnouncement = res;
        if (res.trim() === '') {
          this.globalNotificationHidden = true;
        } else {
          this.globalNotificationHidden = false;
        }
      }
      this.cdr.detectChanges();
    });

    this.subscribers.alertNotifications = this.alertService.$notifications.subscribe((items) => {
      this.notifications = items;
      this.notificationCount = items.filter((n) => !n.read).length;
      this.cdr.detectChanges();
    });
  }

  get prompts() {
    return this.promptsService.prompts;
  }

  get safeUrl() {
    if (!this.organization || this.organization.logoBase64 === null) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.organization.logoBase64);
  }

  public hideNotification(): void {
    this.notificationHidden = true;
  }

  public hideGlobalNotification(): void {
    this.globalNotificationHidden = true;
  }

  public onNotificationPanelOpen(): void {
    this.alertService.markAllRead();
  }

  public clearNotifications(): void {
    this.alertService.clearHistory();
  }

  public getNotificationIcon(type: string): string {
    switch (type) {
      case 'error': return 'error_outline';
      case 'success': return 'check_circle_outline';
      case 'warn': return 'warning_amber';
      default: return 'info_outline';
    }
  }

  toggleCollapse() {
    this.dashboardHelper.setToggleLeftIconPanelCollapse(true);
    setTimeout(() => {
      this.dashboardHelper.setToggleLeftIconPanelCollapse(false);
    }, 4000);
    this.dashboardHelper.setShowRightPanel(false);
  }

  OnNavigateToProjectsView() {
    if (!this.isClassicETActive) return;
    this.projectStore.loadInitialData();
    //@todo - later handle screen change in one place , need to design it
    this.setCurrentApp();
    this.dashboardHelper.setExpandRightPanel(false);
    this.dashboardHelper.setShowRightPanel(false);
    this.dashboardHelper.setShowLeftSidePanel(false);
    this.dashboardHelper.setShowGraphPanel(false);
    this.dashboardHelper.setToggleLeftPanelCollapse(false);
    if (this.subscribers.selectedBlueprint) {
      this.subscribers.selectedBlueprint.unsubscribe();
      this.subscribers.selectedBlueprint = null;
    }
    this.router.navigate([
      '/',
      'dashboard',
      {
        outlets: {
          leftSidePanel: ['blank'],
          mainPanel: ['projectsview'],
          tabPanel: ['blank'],
          rightPanel: ['blank'],
        },
      },
    ]);
  }
  private getMainPanelValue(): string {
    let mainPanelUrl = '';
    let routerState = this.router.routerState.snapshot.root;
    while (routerState.firstChild) {
      routerState = routerState.firstChild;
      if (routerState.outlet === 'mainPanel') {
        mainPanelUrl = routerState.url.map((segment) => segment.path).join('/');
        break;
      }
    }
    return mainPanelUrl?.toLowerCase() ?? '';
  }

  private setCurrentApp() {
    var classicLink = this.externalLinkStore.getAppLink(AppNames.Classic);

    this.dashboardHelper.currentETApplication = classicLink ?? null;
  }
  public openVideoPanel() {
    if (this.getMainPanelValue() === 'products') return;
    this.dashboardHelper.setShowRightPanel(true);
    this.dashboardHelper.showVideoList = true;
    this.router.navigate(
      [
        '/',
        'dashboard',
        {
          outlets: {
            rightPanel: ['videoList'],
          },
        },
      ],
      { queryParamsHandling: 'preserve' },
    );
  }
}
